<ngx-spinner
        id="spinner"
        bdColor="rgba(0,0,0,0.2)"
        size="large"
        color="#2496be"
        type="ball-clip-rotate-multiple">
</ngx-spinner>
<router-outlet *ngIf="!underMaintenance"></router-outlet>
<div *ngIf="underMaintenance" style="height: 100%;">
	<head>
		<title>Site Maintenance</title>
		<style>
			body { text-align: center; padding: 20px; font: 20px Helvetica, sans-serif; color: #333; background-color: #f0f2f5; }
			@media (min-width: 768px){
				body{ padding-top: 20px; }
			}
			h1 { font-size: 50px; }
			article { display: block; text-align: center; max-width: 650px; margin: 0 auto; }
			a { color: #33cc99; text-decoration: none; }
			a:hover { color: #19644e; text-decoration: none; }
			span { color: #33cc99; text-decoration: none; }
			span:hover { color: #19644e; text-decoration: none; }
		</style>
	</head>
	<body>
	<article>
		<div style="margin-bottom: 20px;">
			<img (click)="changeLanguage('de_DE')" style="cursor: pointer; width:2rem; height: 2rem; margin-right: 1rem;" src="assets/country-flags/4x3/de.svg">
			<img (click)="changeLanguage('en_US')" style="cursor: pointer; width:2rem; height: 2rem;" src="assets/country-flags/4x3/en.svg">
		</div>
		<div style="margin-bottom: 20px;">
			<div class="logo-wrapper">
				<img alt="tenderpilot-logo" src="../../../assets/logo/tp-logo-voll-quer.svg" width="390">
			</div>
		</div>
		<h1>{{ 'global.public.maintenance.back_soon' | translate }}</h1>
		<div>
			<p>{{ 'global.public.maintenance.message1' | translate }} </p>
			<p>
				{{ 'global.public.maintenance.with_email' | translate }}
				<a href="mailto:csm@tenderpilot.de">csm@tenderpilot.de</a>
				{{ 'global.public.maintenance.or_phone' | translate }}
				<a href="tel:+4954193935500">+49 541 939 355 00</a>, <br>
				{{ 'global.public.maintenance.message2' | translate }}
			</p>
			<p>
				{{ 'global.public.maintenance.message3' | translate }}<br>
				<b>{{ currentMaintenance.end | date:'EEEE dd MMMM yyyy, HH:mm':timezone:locale}}</b>
			</p>
			<p>&mdash; {{ 'global.public.maintenance.team' | translate }}</p>
		</div>
	</article>
	</body>
</div>
